import Button from "../../../../components/button";
import styles from "./styles.module.css";

const ConfirmationDeleteUserModal = ({
  userName,
  handleClose,
  handleDelete,
}) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalCard}>
        <div className={styles.modalTitle}>
          <h3>Confirmar Eliminación de Usuario</h3>
        </div>
        <div className={styles.formGroup}>
          <div className={styles.alert} role="alert">
            ¿Estás seguro de que deseas eliminar a este usuario: {userName}?
          </div>
          <div className={styles.buttonGroup}>
            <Button variant="destructive" onClick={handleDelete}>
              Eliminar
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmationDeleteUserModal;
